import http from "@/util/http.js"
const PREFIX = "/beneficiario/importacao"

import { downloadPost } from "@/util/utils"

export default {
    async getImportacaoAtiva(customConfig)
    {
        return await http.get(PREFIX +  "/active", { customConfig })
    },
    async sendBach(batch, customConfig)
    {
        return await http.post(PREFIX, batch, {headers: { 'Content-Type': 'multipart/form-data' }, customConfig})
    },
    async filtrar(importacaoId, params, customConfig)
    {
        return await http.get(PREFIX +  "/" + importacaoId + "/line", { params, customConfig })
    },
    async ativarImportacao(importacaoId, customConfig)
    {
        return await http.post(PREFIX +  "/" + importacaoId + "/ativar", null, { customConfig })
    },
    async desativarImportacao(importacaoId, customConfig)
    {
        return await http.post(PREFIX +  "/" + importacaoId + "/desativar", null, { customConfig })
    },
    async getLineImportacao(importacaoId, line, customConfig)
    {
        return await http.get(PREFIX +  "/" + importacaoId + "/line/" + line , { customConfig })
    },
    async deleteLineImportacao(importacaoId, line, customConfig)
    {
        return await http.delete(PREFIX +  "/" + importacaoId + "/line/" + line , { customConfig })
    },
    async deleteLinesImportacao(importacaoId, line, customConfig)
    {
        return await http.delete(PREFIX +  "/" + importacaoId + "/lines/" + line , { customConfig })
    },
    async checkImportacao(importacaoId, customConfig)
    {
        return await http.get(PREFIX +  "/" + importacaoId + "/validate", { customConfig })
    },
    async iniciarImportacao(importacaoId, customConfig)
    {
        return await http.post(PREFIX +  "/start" , { importacaoId, customConfig })
    },
    async salvarImportacao(beneficiarioRow, customConfig)
    {
        return await http.post(PREFIX +  "/line" , beneficiarioRow, { customConfig })
    },
    async deletarImportacao(importacaoId, customConfig)
    {
        return await http.delete(PREFIX +  "/" + importacaoId, { customConfig })
    },
    async finalizarImportacao(importacaoId, customConfig)
    {
        return await http.patch(PREFIX +  "/" + importacaoId, { customConfig })
    },
    async validarImportacao(beneficiarioRow, customConfig)
    {
        return await http.post(PREFIX +  "/line/validate" , beneficiarioRow, { customConfig })
    },
    async getEstatisticas(customConfig)
    {
        return await http.get(PREFIX +  "/estatisticas", { customConfig })
    },
    async uploadFile(form, empresaId, produtoId, tipo, customConfig)
    {
        let url = PREFIX + "/upload-file?empresa="+empresaId+'&produto='+produtoId+'&tipo='+tipo
        
        return http.post(url, new FormData(form), {headers: { 'Content-Type': 'multipart/form-data' }, customConfig})
    },
    async downloadFile(importacaoId)
    {
        return downloadPost(PREFIX +  "/" + importacaoId + "/download-file")
    },
    async getEmpresas(importacaoId, customConfig)
    {
        return await http.get(PREFIX +  "/" + importacaoId + "/empresas", { customConfig })
    },
    async numeroBeneficiariosSeraoInativados(importacaoId, empresasIds, customConfig)
    {
        return await http.post(PREFIX +  "/" + importacaoId + "/beneficiarios/total/inativar", empresasIds, { customConfig })
    },
    downloadLinhasInvalidas(importacaoId)
    {
        downloadPost(PREFIX +  "/" + importacaoId + "/download-linhas-invalidas")
    },
    async getHistoricoImportacao(empresaId, email, nome, periodo, produto, page, size, customConfig)
    {
        return await http.get(PREFIX + "/historico-importacao", { params: { empresaId, email, nome, periodo, produto, page, size }, customConfig });
    },
    async consultarHistoricoInativo(filter, customConfig)
    {
        return await http.get(PREFIX +  "/historico-inativacao", { params: { ...filter }, customConfig })
    },
    async getHistoricoBeneficiario(filter, customConfig)
    {
        return await http.get(PREFIX +  "/beneficiario", { params: { ...filter }, customConfig })
    },
    async adicionar(beneficiarioRow, customConfig)
    {
        return await http.post(PREFIX +  "/beneficiario" , beneficiarioRow, { customConfig })
    },
    async inativar(beneficiarioRow, customConfig)
    {
        return await http.post(PREFIX +  "/beneficiario/inativar" , beneficiarioRow, { customConfig })
    },
    async dependentes(beneficiarioId, customConfig)
    {
        return await http.get(PREFIX +  "/beneficiario/"+beneficiarioId + "/dependentes" , { customConfig })
    },
    async beneficiario(beneficiarioId, customConfig)
    {
        return await http.get(PREFIX +  "/beneficiario/"+beneficiarioId , { customConfig })
    },
    async totalBeneficiario(tipo, status, empresa,  customConfig)
    {
        return await http.get(PREFIX +  "/beneficiario/total", { params: { tipo, status, empresa }, customConfig })
    },
    async getLinesErrors(params, customConfig)
    {
        return await http.get(PREFIX +  "/line/errors", { params, customConfig })
    },
  }